module.exports = __webpack_public_path__ + "static/media/mobile_mockup_2.cd560c36.png";